import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoanOffersPage from './components/LoanOffersPage/LoanOffersPage';
import LoanApplication from './components/LoanApplication/LoanApplication';
import AutoApplication from './components/AutoApplication/AutoApplication';
import ReviewOffer from './components/ReviewOffer/ReviewOffer';
import EndPage from './components/EndPage/EndPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Set the root path to the LoanOffersPage */}
        <Route path="/" element={<LoanOffersPage />} />
        {/* Add route for LoanApplication */}
        <Route path="/loan-application" element={<LoanApplication />} />
        {/* Add route for AutoApplication */}
        <Route path="/auto-application" element={<AutoApplication />} />
        {/* Add route for ReviewOffer */}
        <Route path="/review" element={<ReviewOffer />} />
        {/* Add route for EndPage */}
        <Route path="/end-page" element={<EndPage />} />
      </Routes>
    </Router>
  );
}

export default App;
